/**
 * Cookie Consent Manager - LGPD Compliance
 * Gerencia consentimento de cookies conforme a Política de Privacidade da Ytech.
 *
 * Categorias:
 *  - essenciais: sempre ativos (funcionamento do site)
 *  - analiticos: Google Analytics e similares
 *  - terceiros: Google Maps, CDNs externos, redes sociais
 */
(function () {
  "use strict";

  var COOKIE_NAME = "ytech_cookie_consent";
  var COOKIE_DAYS = 365;

  // Estado padrão: tudo recusado exceto essenciais
  var defaultConsent = {
    essenciais: true,
    analiticos: false,
    terceiros: false,
  };

  /** Lê o consentimento salvo ou retorna null */
  function getConsent() {
    try {
      var match = document.cookie.match(
        new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]*)"),
      );
      if (match) return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  /** Salva o consentimento como cookie */
  function setConsent(consent) {
    var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie =
      COOKIE_NAME +
      "=" +
      encodeURIComponent(JSON.stringify(consent)) +
      "; expires=" +
      expires +
      "; path=/; SameSite=Lax";
  }

  /** Aplica o consentimento: ativa/desativa recursos */
  function applyConsent(consent) {
    // Google Maps: só carrega se terceiros aceito
    var mapFrames = document.querySelectorAll(
      '[data-cookie-category="terceiros"]',
    );
    for (var i = 0; i < mapFrames.length; i++) {
      var el = mapFrames[i];
      if (consent.terceiros) {
        if (el.tagName === "IFRAME" && !el.src && el.dataset.src) {
          el.src = el.dataset.src;
        }
        if (el.classList.contains("cookie-blocked-placeholder")) {
          el.style.display = "none";
          var target = el.previousElementSibling || el.nextElementSibling;
          if (target && target.tagName === "IFRAME") target.style.display = "";
        }
      } else {
        if (el.tagName === "IFRAME" && el.src) {
          el.dataset.src = el.src;
          el.src = "about:blank";
          el.style.display = "none";
          // Mostra placeholder se existir
          var placeholder = el.parentElement.querySelector(
            ".cookie-blocked-placeholder",
          );
          if (placeholder) placeholder.style.display = "";
        }
      }
    }

    // Analytics: disparar evento para scripts que ouçam
    if (consent.analiticos && typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
      });
    }

    // Dispara evento customizado
    window.dispatchEvent(
      new CustomEvent("cookieConsentChanged", { detail: consent }),
    );
  }

  /** Cria e insere o banner de consentimento */
  function showBanner() {
    if (document.getElementById("cookieConsentBanner")) return;

    var banner = document.createElement("div");
    banner.id = "cookieConsentBanner";
    banner.className = "cookie-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-label", "Consentimento de Cookies");
    banner.innerHTML =
      '<div class="cookie-banner-content">' +
      '<div class="cookie-banner-text">' +
      '<svg class="cookie-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' +
      "</svg>" +
      "<div>" +
      "<strong>Privacidade e Cookies</strong>" +
      "<p>Utilizamos cookies para melhorar sua experiência. Cookies essenciais são necessários para o funcionamento do site. " +
      "Você pode aceitar todos ou gerenciar suas preferências. " +
      '<a href="./privacidade.html#cookies">Saiba mais</a></p>' +
      "</div>" +
      "</div>" +
      '<div class="cookie-banner-actions">' +
      '<button id="cookieAcceptAll" class="cookie-btn cookie-btn-accept">Aceitar Todos</button>' +
      '<button id="cookieRejectAll" class="cookie-btn cookie-btn-reject">Apenas Essenciais</button>' +
      '<button id="cookieManage" class="cookie-btn cookie-btn-manage">Gerenciar</button>' +
      "</div>" +
      "</div>";

    document.body.appendChild(banner);

    // Forçar reflow para animar
    banner.offsetHeight;
    banner.classList.add("cookie-banner-visible");

    document
      .getElementById("cookieAcceptAll")
      .addEventListener("click", function () {
        var consent = { essenciais: true, analiticos: true, terceiros: true };
        setConsent(consent);
        applyConsent(consent);
        closeBanner();
      });

    document
      .getElementById("cookieRejectAll")
      .addEventListener("click", function () {
        var consent = { essenciais: true, analiticos: false, terceiros: false };
        setConsent(consent);
        applyConsent(consent);
        closeBanner();
      });

    document
      .getElementById("cookieManage")
      .addEventListener("click", function () {
        showPreferences();
      });
  }

  /** Fecha e remove o banner */
  function closeBanner() {
    var banner = document.getElementById("cookieConsentBanner");
    if (banner) {
      banner.classList.remove("cookie-banner-visible");
      setTimeout(function () {
        banner.remove();
      }, 300);
    }
  }

  /** Mostra o modal de preferências de cookies */
  function showPreferences() {
    if (document.getElementById("cookiePrefsModal")) return;

    var current = getConsent() || defaultConsent;

    var modal = document.createElement("div");
    modal.id = "cookiePrefsModal";
    modal.className = "cookie-prefs-overlay";
    modal.innerHTML =
      '<div class="cookie-prefs-modal" role="dialog" aria-label="Preferências de Cookies">' +
      '<div class="cookie-prefs-header">' +
      "<h3>Preferências de Cookies</h3>" +
      '<button id="cookiePrefsClose" class="cookie-prefs-close" aria-label="Fechar">&times;</button>' +
      "</div>" +
      '<div class="cookie-prefs-body">' +
      '<div class="cookie-category">' +
      '<div class="cookie-category-header">' +
      "<strong>Cookies Essenciais</strong>" +
      '<span class="cookie-always-on">Sempre Ativo</span>' +
      "</div>" +
      "<p>Indispensáveis para o funcionamento do site. Sem esses cookies, certos serviços podem ser desativados.</p>" +
      "</div>" +
      '<div class="cookie-category">' +
      '<div class="cookie-category-header">' +
      "<strong>Cookies Analíticos</strong>" +
      '<label class="cookie-toggle">' +
      '<input type="checkbox" id="cookiePrefAnaliticos"' +
      (current.analiticos ? " checked" : "") +
      ">" +
      '<span class="cookie-toggle-slider"></span>' +
      "</label>" +
      "</div>" +
      "<p>Coletam informações sobre como os visitantes utilizam o site, possibilitando o aprimoramento contínuo dos serviços.</p>" +
      "</div>" +
      '<div class="cookie-category">' +
      '<div class="cookie-category-header">' +
      "<strong>Cookies de Terceiros</strong>" +
      '<label class="cookie-toggle">' +
      '<input type="checkbox" id="cookiePrefTerceiros"' +
      (current.terceiros ? " checked" : "") +
      ">" +
      '<span class="cookie-toggle-slider"></span>' +
      "</label>" +
      "</div>" +
      "<p>Podem ser instalados por serviços externos integrados ao site, como Google Maps e redes sociais.</p>" +
      "</div>" +
      "</div>" +
      '<div class="cookie-prefs-footer">' +
      '<button id="cookiePrefsSave" class="cookie-btn cookie-btn-accept">Salvar Preferências</button>' +
      "</div>" +
      "</div>";

    document.body.appendChild(modal);
    modal.offsetHeight;
    modal.classList.add("cookie-prefs-visible");

    document
      .getElementById("cookiePrefsClose")
      .addEventListener("click", closePreferences);
    modal.addEventListener("click", function (e) {
      if (e.target === modal) closePreferences();
    });

    document
      .getElementById("cookiePrefsSave")
      .addEventListener("click", function () {
        var consent = {
          essenciais: true,
          analiticos: document.getElementById("cookiePrefAnaliticos").checked,
          terceiros: document.getElementById("cookiePrefTerceiros").checked,
        };
        setConsent(consent);
        applyConsent(consent);
        closePreferences();
        closeBanner();
      });
  }

  /** Fecha o modal de preferências */
  function closePreferences() {
    var modal = document.getElementById("cookiePrefsModal");
    if (modal) {
      modal.classList.remove("cookie-prefs-visible");
      setTimeout(function () {
        modal.remove();
      }, 300);
    }
  }

  /** Expõe função global para reabrir preferências (link no footer, etc.) */
  window.openCookiePreferences = showPreferences;

  /** Inicialização */
  function init() {
    var consent = getConsent();
    if (consent) {
      applyConsent(consent);
    } else {
      // Bloqueia terceiros até consentimento
      applyConsent(defaultConsent);
      showBanner();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
